import { BigFormRow } from 'framework/ui/layout';
import { TextInput, WysiwygInput } from 'framework/form';
import { ARTIFACT_ID } from 'domain/shared/artifact';
import CompositeDocumentUploaderInput from 'domain/sales/opportunity/shared/storage/components/CompositeDocumentUploaderInput';

interface NoteFormProps {
  isStrategy?: boolean;
}

const NoteForm = ({ isStrategy = false }: NoteFormProps) => (
  <>
    {!isStrategy && (
      <BigFormRow>
        <TextInput source="subject" />
      </BigFormRow>
    )}
    <BigFormRow>
      <WysiwygInput source="description" />
    </BigFormRow>
    {!isStrategy && (
      <BigFormRow>
        <CompositeDocumentUploaderInput
          label="Attachments"
          artifactTypeId={ARTIFACT_ID.CRM_ATTACHMENT}
          artifactsListSource={'attachmentsIds'}
          documentsListsSource={'artifactPaths'}
        />
      </BigFormRow>
    )}
  </>
);

export default NoteForm;
